<template>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Coin Name/Type
            </th>
            <th class="text-left">
              Amount ($)
            </th>
            <th class="text-left">
              Quantity
            </th>
            <th class="text-left">
              Wallet Users
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in coins"
            :key="item.id"
          >
            <td>{{ item.coinShortName }}</td>
            <td>{{ formatMoney(item.tradeSumUSD) }}</td>
            <td>{{ item.tradeSumCoinValue }}</td>
            <td>{{ item.trade_count }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </template>


  <script>
  // ============== IMPORT SERVICES ============
  import {formatMoney} from '@/utils/moneyFormatter';

  export default {
    props: {
      coins: Array
    },
    data () {
      return {
      
      }
    },
    methods: {
      formatMoney(amount){
            return formatMoney(amount, false)
      },
    }
  }
</script>

<style>
td {
    size: 0.1rem;
}
</style>